import styled from 'styled-components';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';

export const StyledIconButton = styled(IconButton)`
  padding: 0;
  border-radius: 0;
  margin-right: -14px;

  &:hover {
    background-color: transparent;
  }

  svg {
    font-size: 3.2rem;
  }
`;
export const MenuStyled = styled(Menu)`
  .more-nav {
    &__icon {
      font-size: 1.6rem;
      margin-right: 16px;
    }
  }

  .MuiList-root {
    padding: 0;
  }

  .MuiListItem-root {
    font-size: 1.6rem;
    font-weight: 400;

    &:hover {
      color: inherit;
    }
  }
`;
export default MenuStyled;
